import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, ResizeObserver } from './modules';
export var Sidebar = function () {
    return (_jsxs("aside", { children: [_jsx(Menu, {}), _jsx(ResizeObserver, {})] }));
};
